import { render } from "./TInputText.vue?vue&type=template&id=09d5f5bf&scoped=true"
import script from "./TInputText.vue?vue&type=script&lang=js"
export * from "./TInputText.vue?vue&type=script&lang=js"

import "./TInputText.vue?vue&type=style&index=0&id=09d5f5bf&lang=scss&scoped=true"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d5f5bf"]])

export default __exports__